export interface ChangePasswordFormFields {
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
}

export enum ChangePasswordStep {
  Form = 'form',
  Success = 'success',
}
